"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconTaxFilled = function IconTaxFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "25",
    cy: "31.5",
    r: "3.5",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30,22l-.89-.9-.83.9-1.56,1.69L25.46,25H36a3,3,0,0,0,3,3v7a3,3,0,0,0-3,3H14a3,3,0,0,0-3-3V28a3,3,0,0,0,3-3h4.07l-3,3.06L15,32h2L30.49,17.51a4.49,4.49,0,1,0-2.49-4,4.58,4.58,0,0,0,.21,1.29L25.5,17.52l-2.71-2.73A4.58,4.58,0,0,0,23,13.5a4.54,4.54,0,1,0-2.49,4L23,20l-2,2H8V41H42V22ZM32.5,11A2.5,2.5,0,1,1,30,13.5,2.5,2.5,0,0,1,32.5,11Zm-14,5A2.5,2.5,0,1,1,21,13.5,2.5,2.5,0,0,1,18.5,16Z",
    fill: color
  }));
};

IconTaxFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconTaxFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconTaxFilled;
exports.default = _default;